export const supplementalLessonsIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'Supplemental Lessons is where you can download additional support materials. Curriculum Packets contain additional lessons designed to support students in building comprehension, fluency, phrasing, and spelling knowledge.'
  },
  {
    element: '.student-dropdown-row',
    intro: 'Select a Sub-Category from the dropdown to view the Student or Teacher Version or both.'
  },
  {
    element: '#resourcesTable tbody tr:first-child',
    intro: 'See the Guide for Using Instructional Curriculum Packets and Syllable Types and Vowel Pronunciation files for additional information on how to use the curriculum packets. Scroll until you find the unit Curriculum Packet you want to download. Click the file to download it.'
  }
];
